import React, { useContext } from 'react';
import { LanguageContext } from '../components/LanguageContext';
import { Card } from 'antd';

const Magazines = () => {
  const { language } = useContext(LanguageContext);
  const magazines = [];

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="relative">
        <div className="h-[300px] relative">
          <img 
            src="https://th-i.thgim.com/public/migration_catalog/article10456065.ece/alternates/FREE_1200/amaravathi"
            alt={language === 'en' ? "Academy Magazines Header" : "اکیڈمی میگزین ہیڈر"} 
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-blue-900/40">
            <div className="container mx-auto px-8 h-full flex items-center">
              <div className="max-w-2xl text-white">
                <h1 className="text-3xl md:text-5xl font-bold mb-4">
                  {language === 'en' ? "Monthly Magazine" : "ماہانہ رسالہ"}
                </h1>
                <p className="text-lg md:text-xl">
                  {language === 'en'
                    ? "Explore our collection of Urdu literature and culture"
                    : "اردو ادب اور ثقافت کا ہمارا مجموعہ دریافت کریں"}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-6 md:py-12">
        {magazines.length === 0 ? (
          <Card className="text-center p-8 shadow-md">
            <h2 className="text-2xl font-bold text-blue-800 mb-2">
              {language === 'en' ? "Our Magazine Collection is Coming Soon!" : "ہمارا میگزین کلیکشن جلد آ رہا ہے!"}
            </h2>
            <p className="text-gray-600">
              {language === 'en' 
                ? "We're preparing something special for you. Stay tuned!" 
                : "ہم آپ کے لیے کچھ خاص تیار کر رہے ہیں۔ منتظر رہیں!"}
            </p>
          </Card>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {magazines.map((magazine) => (
            <div key={magazine.id} className="p-4 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow overflow-hidden">
              <div className="h-48 relative">
                <img 
                  src={magazine.coverImage}
                  alt={magazine.title}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="mt-4">
                <div className="flex items-center justify-between mb-2">
                  <h2 className="text-xl font-semibold">{magazine.title}</h2>
                  <span className="text-blue-800 font-medium">{magazine.month}</span>
                </div>
                <p className="text-gray-600">{magazine.description}</p>
              </div>
              <button className="w-full mt-4 bg-blue-800 text-white py-2 rounded-lg hover:bg-blue-900 transition-colors flex items-center justify-center gap-2">
                <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zm0 12.5c-2.89 0-5.28-2.39-5.28-5.33S9.11 6.34 12 6.34s5.28 2.39 5.28 5.33-2.39 5.33-5.28 5.33zm0-8.5c-1.71 0-3.09 1.38-3.09 3.09s1.38 3.09 3.09 3.09 3.09-1.38 3.09-3.09-1.38-3.09-3.09-3.09z" />
                </svg>
                {language === 'en' ? "View PDF" : "پی ڈی ایف دیکھیں"}
              </button>
            </div>
          ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Magazines;




